export default "__VITE_ASSET__CIzeDwj1__"